
<div class="modal-header border-b">
    <h4 class="modal-title title">{{modelHeader}}</h4> 
    <h4 class="modal-title title" style="margin-left: 30%;">{{environment}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body margin-td">
    <div class="card scrollbar">
        <div class="card-content">
          <div class="card-body">

            <div class="row">
             
                <div class="col-6">
                    <div class="af-form-group">
                      <label translate>{{'lblSyncFrom' | translate}} :</label>
                      <div class="lbl-info">
                        DMS
                      </div>
                    </div>  
                   
                  </div>
                  <div class="col-6">
                    <div class="af-form-group">
                      <label>{{'lblSyncTo' | translate}} :</label>
                      <div class="lbl-info">
                       AFX
                      </div>
                    </div>  
                  </div>
                  <div class="col-6">
                <div class="af-form-group">
                  <label translate>{{'lblFeatureName' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.module}}
                  </div>
                </div>
                </div>  
              <div class="col-6">
                <div class="af-form-group">
                  <label>{{'lblSyncUser' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.name}} 
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label>{{'lblStartDate' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.startDate | date : 'short'}} 
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label>{{'lblEndDate' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.endDate | date : 'short'}}
                  </div>
                </div>  
              </div>

              <div class="col-12">
                <div class="af-form-group">
                  <label translate> {{'lblSyncMessage' | translate}}: </label>
                  <div class="lbl-info">
                    <textarea class="form-control" readonly style="height:400px!important">{{dmsLogList.exceptionMessage}}</textarea>
                  
                  </div>
                </div>  
              </div>
             
            </div>
            
          </div>
        </div>
        
      </div>
  </div>
  <div class="modal-footer">
   
<button type="button" class="btn btn-secondary" aria-label="Center Align" (click)="activeModal.dismiss(false)" translate>lblClose</button>
</div>